import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import ReactGA from "react-ga4";
import { PrayerProvider } from "./context/PrayerContext";
import MainPage from "./pages/MainPage";
import LoadingPage from "./pages/LoadingPage";
import ResultPage from "./pages/ResultPage";
import "./styles/globals.css";
import "./App.css";

// GA4 초기화
if (process.env.REACT_APP_GA_KEY) {
  ReactGA.initialize(process.env.REACT_APP_GA_KEY);
}

// 페이지뷰 추적 컴포넌트
function GoogleAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (process.env.REACT_APP_GA_KEY) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <PrayerProvider>
      <Router>
        <GoogleAnalyticsTracker />
        <div className="App">
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/loading" element={<LoadingPage />} />
            <Route path="/result" element={<ResultPage />} />
          </Routes>
        </div>
      </Router>
    </PrayerProvider>
  );
}

export default App;
